<script>
import CommonTableComponent from "@/components/table.vue";

export default {
  components: {CommonTableComponent},
  props: {
    treatmentContract: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    removeContract() {
      this.$emit("removeContract");
    },
  },
}
</script>

<template>
  <CommonTableComponent :height-class="`table-wrapper-300`">
    <thead class="table-light">
    <tr>
      <th style="width: 30%">CB管理番号</th>
      <th style="width: 60%">処分契約名</th>
      <th v-if="!disabled"></th>
    </tr>
    </thead>
    <tbody>
    <tr v-if="treatmentContract">
      <td>{{treatmentContract.treatment_contract_cd}}</td>
      <td>{{treatmentContract.treatment_contract_name}}</td>
      <td v-if="!disabled" class="text-center">
        <b-button class="btn-custom-red" @click="removeContract"><i class="fas fa-eraser"></i> 削除</b-button>
      </td>
    </tr>
    </tbody>
  </CommonTableComponent>
</template>
